// extracted by mini-css-extract-plugin
export var menuIcon = "_ru-0";
export var menuIconInline = "_ru-1";